import Vue from "vue";
import Router from "vue-router";
import Main from "@/components/Main";

import index from "@/components/mode/index";
import index_old from "@/components/mode/index_old";
import app from "@/components/mode/app";
import kefu from "@/components/mode/kefu";
import gamePage from "@/components/mode/gamePage";
import hongbao from "@/components/mode/hongbao";
import activity from "@/components/mode/activity";
import activity_old from "@/components/mode/activity_old";
import zhanzhu from "@/components/mode/zhanzhu";
import mine from "@/components/mode/mine";
import mine_old from "@/components/mode/mine_old";
import lotteryPage from "@/components/mode/lotteryPage.vue";

import login from "@/components/login";
import activityInfo from "@/components/activityInfo";
import zhanzhuye from "@/components/zhanzhuye";
import vip from "@/components/vip";
import applyagent from "@/components/applyagent";
import boutBallBet from "@/components/boutBallBet";
import boutBallBetInfo from "@/components/boutBallBetInfo";
import message from "@/components/message";
import fanshui from "@/components/fanshui";
import userInfo from "@/components/userInfo";
import userCent from "@/components/userCent";
import wallet from "@/components/wallet";
import addUsdtCard from "@/components/addUsdtCard";
import addBankCard from "@/components/addBankCard";
import usdtmore from "@/components/usdtmore";
import password from "@/components/password";
import welfare from "@/components/welfare";
import betRecord from "@/components/betRecord";
import activityRecord from "@/components/activityRecord";
import transRecord from "@/components/transRecord";
import money from "@/components/money";
import recharge from "@/components/recharge";
import payInfo from "@/components/payInfo";
import withdrawal from "@/components/withdrawal";
import transfer from "@/components/transfer";
import concise from "@/components/mode/concise";
import dialogue from "@/components/dialogue";
import reg from "@/components/reg";
import reg2 from "@/components/reg2";
import iframepage from "@/components/iframepage";
import vip2 from "@/components/vip2";
import inviter from "@/components/inviter";
import withdrawAccount from "@/components/withdrawAccount";
import discover from "@/components/mode/discover";
import account from "@/components/account";

Vue.use(Router);

export default new Router({
  // mode: 'history',

  // meta: {
  //   requireAuth: true,
  //   keepAlive: true,//是否缓存组件
  //   useCatch:false//是否用缓存
  // }
  mode: "hash",

  routes: [
    {
      path: "/",
      name: "Main",
      component: Main,
      children: [
        {
          path: "",
          name: "dialogue",
          component: dialogue,
          meta: {
            keepAlive: true, //是否缓存组件
            useCatch: false, //是否用缓存
          },
        },
	  	
        {
          path: "/home",
          name: "index",
          component: index,
          meta: {
            keepAlive: true, //是否缓存组件
            useCatch: false, //是否用缓存
          },
        },
        {
          path: "/discover",
          name: "discover",
          component: discover,
          meta: {
            keepAlive: true, //是否缓存组件
            useCatch: false, //是否用缓存
          },
        },
        {
          path: "/index_old",
          name: "index_old",
          component: index_old,
          meta: {
            keepAlive: true, //是否缓存组件
            useCatch: false, //是否用缓存
          },
        },
        {
          path: "/hongbao",
          name: "hongbao",
          component: hongbao,
        },
        {
          path: "/activity",
          name: "activity",
          component: activity,
          meta: {
            keepAlive: true, //是否缓存组件
            useCatch: false, //是否用缓存
          },
        },
        {
          path: "/activity_old",
          name: "activity_old",
          component: activity_old,
          meta: {
            keepAlive: true, //是否缓存组件
            useCatch: false, //是否用缓存
          },
        },
        {
          path: "/zhanzhu",
          name: "zhanzhu",
          component: zhanzhu,
          meta: {
            keepAlive: true, //是否缓存组件
            useCatch: false, //是否用缓存
          },
        },
        {
          path: "/mine",
          name: "mine",
          component: mine,
          meta: {
            keepAlive: true, //是否缓存组件
            useCatch: false, //是否用缓存
            requireAuth: true,
          },
        },
        {
          path: "/mine_old",
          name: "mine_old",
          component: mine_old,
          meta: {
            keepAlive: true, //是否缓存组件
            useCatch: false, //是否用缓存
            requireAuth: true,
          },
        },
        {
          path: "/app",
          name: "app",
          component: app,
          meta: {
            keepAlive: true, //是否缓存组件

            useCatch: false, //是否用缓存
            requireAuth: true,
          },
        },
      ],
    },
    {
      path: "/agent",
      component: () => import("@/pages/agent/Index.vue"),
      children: [
        {
          path: "",
          name: "agent-home",
          component: () => import("@/pages/agent/Home.vue"),
          meta: {
            title: "首页",
            active: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFgAAABYCAMAAABGS8AGAAABKVBMVEUAAACuX/+xW/+8Sv61VP63Uv6yWP/EQP25T/67TP7BRP3CQ/20Vv64Uf6yVv++SP6/Rv7FP/26Tv7ARv7GPf24Uf+4U/+vXv+vXf+uX/+uX/+vXf+xXP+gYP+uX/+uXv+wW/+xXP+xW/++Qv+uXv/FPv3FPv2uX/+vXf+4TP+uXv+vXv/EQf2vXf+vWv+wX/+yWf/FP/2uXv/GPf2uX//GPv6zV/+xXP+vXv+xXP+tX/+uX//FPvyxWf+5T/7GPfyzV//FPv3HPf20V/+xXf/EQP/GO//GPv/IPf+1Vf63Uv7EP/28S/7GPv2wXv/GPf3FPv3EP/zFPfy5Tf6yWf/BR//GQf+2VP7FP/ywWv+9Sv7FPv69SP2zWP++R/3HPf3GPv2uYP/HPP/tsV+mAAAAY3RSTlMA5ubm5ubm5ubm5ubm5ubm5ubm5uYRDeHY1LurLwTac2EjGwXk4tudSwnfwoiGRCYW1cjBtrWrjoF1bVRKOMzLx6aUbFc+MCMa4tjPvZ2WgHRiXFRBKx/dxrmyqqmgmnFraDfviLcGAAADG0lEQVRYw63ZZ1caQRQG4AEVKTaS7NJh6aEKiNKESCxJbNFETa///0cIBxh2du/uzgz3/ehxHobL3jvMgfDmonpQ2Lwa36sENU83m5MEAgF/8zOme1xYuH7/y2oCzf2U17l7e7+zSO7fIOPu7v4sobgfje7a2neEjzBRNbmTXCurutkbyF3zXTdWc9UfsOvzjTKruMqhlfvCO0rLu+8PrF2vd/Qo6757Y+dub1/G5dyLpr27sXE5lHHPCw7uJF8eJMZD3tldX//wWng8cLkTWXDY/QnyuVtbHk1oPHC7OzueU/42fiviejw9Trc0FnM97hpnG4u6bncnwdPGou40twnnNhZ1ZylmndpYznW5YiX7NpZ1J7Jq18ay7jRtxcq9D0q680QbsHv3StKlqWTA01jaXdKtNNDGsi6TyL7BVcfy+2XluKGNZV1TkkOmjaVdM11+0LWxrAsmVJ+7j02k/VJ5dhD+L8i6lslN5Sd5120rIzy/QMppcoW6X5pbkpdzlyycCPkq5TomRO5Q90sTJaVDcZcjA0LUah59v67ebASdHzu5Jx1tmMlmM0Ot03KsQrSzHHH27pGWITQZLWYPE33s3JNTw1nW6Le4YRv3qE5Mqcd4YWv3F3iDiRc5Yev9Utcgx/hgy/rWiUXqLU4Yfh5svq33OWH4OVPJIvvdSihU6S6P91KMC4b7ghY4UcvNR3itRB/oEAcMuz3q6nYXo9+xNQ4Yng+0EDX9QnrjUDlgeO7Q+ub0B0aO1pkDBl0Kd9mVXQEYdClcYVdWBGB4/pJ5QoZjRwCG57oVIABDLgoMuDiw2UWCTS4ezLpoMOi6EGDQxYAhFwUGXBzY7CLBJhcLNrloMOviwayLCDMuJsy4blyYusg7pi5QiiS7MikAUxf8lyL756IAHIbum2UyTzqsXxhO01WQG2bgb9A9q02oXEzSOhSpS6IQ3GbgFHQ/7hOHpFgSWqWEzffCiOoEKxGzG1EIk7Opy9ocPxicmeGB49vSIMlxVQp49TDzjjh/4Bgw1UgOwIr1ouX5E9P+pxLOKKnFqmQ01SA0z/LFkqQbpye6AAAAAElFTkSuQmCC",
            inactive: "data:image/png;base64,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",
          },
        },
        {
          path: "member",
          name: "agent-member",
          component: () => import("@/pages/agent/Member.vue"),
          meta: {
            title: "会员",
            active: "data:image/png;base64,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",
            inactive: "data:image/png;base64,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",
          },
        },
        {
          path: "invite",
          name: "agent-invite",
          component: () => import("@/pages/agent/Invite.vue"),
          meta: {
            title: "推广",
            active: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFgAAABYCAMAAABGS8AGAAAA2FBMVEUAAACuX/+uXv+vYf+6TP+uX/+wWf+wXP+wXP+yWv+yWv+xWP/FPP+wXP/ARf2vX//GPf3DQv+zV/++SP6wXf+zV/++SP6uX//CQv7ARv2uYP+yX/+2T/+wYP/DQf3RLfzEQP6zV//NMv22U/3MMf3GPP3JOv2uX/+3Uv7DQv3IOv3RLfu3U/7OMv3RLfuzWP+uX/+wXf+1Vf6xWv+5UP66Tf63Uv6/R/6zV/+yWf/MNf28TP7DQv29Sf7OMvy2U/7GPf3FP/3BRP3JOP3IOv3KN/3RLvzPMPw59ZzcAAAAMHRSTlMA8q0mBu8Zlfu2jywZvI9Nkir5+djX19S8lZArKhj7+raYlpIr/fn09NjX19S5j71PYWsBAAADG0lEQVRYw+zX6W7aQBSG4VPJCltAkH2FBEjarD3UiYECpRRS7v+OMlgan/ksWf4uIO9Pa/RoNJpj2bJr+PrU++/abrd/0n6nfXys1+v7x3ZHcl21Tg4Xi8VsNnt3vbmSJFkuf+06OK5fiaRFfWcWuZvN5u9dPwrZ6Hw8Hhe5k8lkOr2N0nUvJa7rLArcszJ3Gjd36/vl7mrVNvi83I3jisiwR7irbnbOHcaNq5fyyrirecvDLcaNR3V5otz5g4dPKHd0JD3KnXc9fEi5o6pQrsvDlOsS0v1nMOM6mHQN5lwVzjWYdFVId2ww5aqQrsGcq4Luy74H9m9C12B0a3v++V4NXBXcr3MzGVyDYb/OzWRwVfAcJMhcgOEcJAhcFXABBneRwYGLMLgq4AIMbgaDCzC4KngfEDbXYLwPeVgNBhdgcGcGB24eVkvABRhcgwM3DyvAMBcSFLoG41wArACDCzC47wYHLsCKMM5xOCDgGgxzHAzIdR4213UTjHToGgxuXLu2kc7Bhe8ddA0ufu8gTLpvHiZdFdI1mHNVONdg0lXhXINJV4V0Ew+Trso95/7w8AHnfpNHyk2ePXxMuXoqbcpNBh6uU65eyPCOcZcNDzdixlW3vs24A8mqMG4l/fQvd3+GvwrNcrcZpSvbZe4t/txUqmX79es7rYdu4T17HjQk12X9qFrkfj+9aMhXX312Y0YpEMIwFKQVv73K3v90C6LEIRXm/fo+E3YWbNPAfCnCP1S2Oc4Hd26EsKf9Q/12/13ZQW496x/uzJreSSx72j/cGc/1g7Dn/cMVLEyEPe0fUrD2DylY+4cUrP1DenjaP6TXzfuHPgQHZ5ADov1DH9vjiekjLbkFFjOY+YeKOMbEP1TExfP+wYO9f4jB3j/kYO8fPFj6hxws/YMHc0CEf9BgjrTwDxbMWRT+wYI5i8I/WDAr0j/kYOUf5CNEsOK6Z5Ngx3176LlLCHbc5WriXzDaP6w+AGuM9g+rI2ON0f5hdclYY7R/SMHaP6Rg7R9SsPYP4eEN7R/C6zYD/9Af815jz/sHrh/WKmfvD71VIBEj3oKlAAAAAElFTkSuQmCC",
            inactive: "data:image/png;base64,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",

          },
        },
        {
          path: "notice",
          name: "agent-notice",
          component: () => import("@/pages/agent/Notice.vue"),
          meta: {
            title: "公告",
            active: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFgAAABYCAMAAABGS8AGAAABXFBMVEUAAACwX/+uX/+2U/+vUP+vX/+2Vv+uX/+uXv+uX/+vXP+uX/+uX/+uXv+uXv+vXv+vXv+vXv+xXv+1Vf+vWv+uX/+uXv+uX/+uXv+uXf+yWv+xW/+wXv+uX/++SP63Uv6uXv+uXv+/R/6uXv+vXv+vXf+uX/+vXv++R/6wX/+7TP7ARf6uX/+7Tf6uX/+vXv/EPv6vX/+vYP/ASP+wYv+/R/7NM/26Tv6vXf/ARf6vXf+vXv+uYP/ARf20Vv/ARf7FPf66TP/FP/6vXv/NNPusYP+/Rv64Uf7NM/zMNf3MNf28S/64Uf7CQ/25UP66Tv7MNPzNM/yuX//LNPy+SP3CRP29S/3MM/y5T/3OM/27Tv+9R/+2Tv+5Uf+uX/+xW/+9Sv61Vf66Tv7DQv25UP63Uf7ARv63U/7BRP2yWf+zV/+7TP7FP/2+SP7KOP3GPf3MNf3HPP3IOv3NM/ziKEgiAAAAXnRSTlMALe8tBDMP2JLoDPetavri3XEhHQjRnot6RjwUEf749fPrzsm+l1xURyr078K6smBZTTgxFuHc0c29pqOgjHVzblpKQTso/fv5+Ojm4uHb2szCtqiiopqVhHxpNjEWv6tJ9QAAA39JREFUWMOt1/dTGkEUwPEXPe+o0osIAtLE3nuMNb33uhg1xmiM7f+fyQHHu+WWsnvs92fnM+vj7TKA3XZGR559DIHsxkYP9S7Gx+SyC1OHNffiaLxfIht6f9lwj46mpLHq/RHKPTlR5bDhBxOXTe6JlFkos0unFvdXv5RVOGVcCfDC2inr9g6HPjxs6f7u73UVzlq7CNtchbM2bi+wMvvirL37s9/+Khx3crvAyuy75SfX19f/qt3e3txcXV391TvW6+yy8F4055mDervLd7pqw2Vgl1cj1WJQ7cudTdcKlwsZYpQAgO1e3HOElVKemDkA9h/34p7fM9iAr6J7lQa8AfCmFxfh9UrNxAKw35v7pw4PVV2K9qnwScxNP2p2DdjRfN7VA4DXIu7Kd1C30rRrwAVqvqnpIdB7KuC+VEEvkabcSh0ukkbZWBBqicxhB2ptUa4BK7k6myuGwYjfxS/OH6bbgEGNDpJMdADMRPYBjNBFWM8VVIBOwEUYXRNmE3ARRrcTLHIvEEa3AyzgIky5pC0s4CJMue1hkfcBYXQpODiABUFPwEUYXRNOaIRKGwIQcBFGF+EBN2lqcB64XQYmFDxNLOVBwEXYcKlROK2wG0TedQquoSbss8JZEHARxvMiXLDCmyDgmrCBmvCw1uz6QiDy/YYwnhfXLRnT+jC/YxFAwEWYYAiz8bs0XOkOC7gVoRMLuGIwvysIc7uiMK/bHU4qQMfpdoNdjgzpc5TBjM/tBiuTpFoqX8JjC7hk0fifWbhkXua48VcT/C6ZgVpeFnbQj/x6AvTW+F3iDIHeQV87GMsHAbb5XV2eUZNedCl4jjTnc4FridOtEIyFYYM05wX4NsLhItsOVuJZQhcFgN3x7i4Te0HCMzliVgC9hRVbc0AYm990E6M9qKZ8fWXLRRgbjvuN34+NEp+nnqdF54sw3Zwn8rYI3RtaJYQLFq/klwxjitcpGcbC8T7JMDYcc0uGsVB00Dbc6r6BWdmTsguzLgG6+Ul7cKv7Zl3riD2YfXfAWrF5rcs8cKv3octap1QeuNX7AC1yxTPEyAM8ma5Zm7V21HcvMswFM+dFmC0Yi/gnA2HgquHSgYzwc5MPoysfRlYujKpcGOcgG0ZXNjxImNxS4CwLO6XAfhbWpMDTLOyRAgdY2CsFTmpWN+ICKakBj+Z0G/vg1DwB++5/yyL06p8MZ7kAAAAASUVORK5CYII=",
            inactive: "data:image/png;base64,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",
          },
        },
        {
          path: "info",
          name: "agent-info",
          component: () => import("@/pages/agent/Info.vue"),
          meta: {
            title: "合营制度",
          },
        },
      ],
    },
    {
      path: "/account",
      name: "account",
      component: account,
    },
    {
      path: "/inviter",
      name: "inviter",
      component: inviter,
    },
    {
      path: "/withdrawAccount",
      name: "withdrawAccount",
      component: withdrawAccount,
    },
    {
      path: "/vip2",
      name: "vip2",
      component: vip2,
    },
    {
      path: "/iframepage",
      name: "iframepage",
      component: iframepage,
    },
    {
      path: "/kefu",
      name: "kefu",
      component: kefu,
    },
    {
      path: "/login",
      name: "login",
      component: login,
    },
    {
      path: "/reg",
      name: "reg",
      component: reg,
    },
    {
      path: "/reg2",
      name: "reg2",
      component: reg2,
    },
    {
      path: "/gamePage",
      name: "gamePage",
      component: gamePage,
    },
    {
      path: "/lottery",
      name: "lottery",
      component: lotteryPage,
    },
    {
      path: "/activityInfo",
      name: "activityInfo",
      component: activityInfo,
    },
    {
      path: "/zhanzhuye",
      name: "zhanzhuye",
      component: zhanzhuye,
    },
    {
      path: "/vip",
      name: "vip",
      component: vip,
      meta: {
        keepAlive: true, //是否缓存组件
        useCatch: false, //是否用缓存
      },
    },
    {
      path: "/applyagent",
      name: "applyagent",
      component: applyagent,
    },
    {
      path: "/boutBallBet",
      name: "boutBallBet",
      component: boutBallBet,
    },
    {
      path: "/boutBallBetInfo",
      name: "boutBallBetInfo",
      component: boutBallBetInfo,
    },
    {
      path: "/message",
      name: "message",
      component: message,
      meta: {
        requireAuth: true,
      },
    },
    {
      path: "/fanshui",
      name: "fanshui",
      component: fanshui,
      meta: {
        requireAuth: true,
      },
    },
    {
      path: "/userInfo",
      name: "userInfo",
      component: userInfo,
      meta: {
        requireAuth: true,
      },
    },
    {
      path: "/userCent",
      name: "userCent",
      component: userCent,
      meta: {
        requireAuth: true,
      },
    },
    {
      path: "/wallet",
      name: "wallet",
      component: wallet,
      meta: {
        requireAuth: true,
      },
    },
    {
      path: "/addBankCard",
      name: "addBankCard",
      component: addBankCard,
      meta: {
        requireAuth: true,
      },
    },
    {
      path: "/addUsdtCard",
      name: "addUsdtCard",
      component: addUsdtCard,
      meta: {
        requireAuth: true,
      },
    },
    {
      path: "/usdtmore",
      name: "usdtmore",
      component: usdtmore,
    },
    {
      path: "/password",
      name: "password",
      component: password,
      meta: {
        requireAuth: true,
      },
    },
    {
      path: "/welfare",
      name: "welfare",
      component: welfare,
      meta: {
        requireAuth: true,
      },
    },
    {
      path: "/betRecord",
      name: "betRecord",
      component: betRecord,
      meta: {
        requireAuth: true,
      },
    },
    {
      path: "/activityRecord",
      name: "activityRecord",
      component: activityRecord,
      meta: {
        requireAuth: true,
      },
    },
    {
      path: "/transRecord",
      name: "transRecord",
      component: transRecord,
      meta: {
        requireAuth: true,
      },
    },
    {
      path: "/money",
      name: "money",
      component: money,
      meta: {
        requireAuth: true,
      },
    },
    {
      path: "/recharge",
      name: "recharge",
      component: recharge,
      meta: {
        requireAuth: true,
        keepAlive: true, //是否缓存组件
        useCatch: false, //是否用缓存
      },
    },
    {
      path: "/payInfo",
      name: "payInfo",
      component: payInfo,
    },
    {
      path: "/concise",
      name: "concise",
      component: concise,
      meta: {
        keepAlive: true, //是否缓存组件
        useCatch: false, //是否用缓存
      },
    },

    {
      path: "/withdrawal",
      name: "withdrawal",
      component: withdrawal,
      meta: {
        requireAuth: true,
      },
    },
    {
      path: "/transfer",
      name: "transfer",
      component: transfer,
      meta: {
        requireAuth: true,
      },
    },
    {
      path: "*", // 重定向页面地址
      redirect: "/home",
    },
  ],
});
